import { formatRoleName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
import { adminRoleName } from '../../utils';
export const deleteRoleStmtInstruction = `
####  Deleting roles
- Syntax: \`delete role <role_name>;\`
- Example: \`delete role editor;\`
`;
export const stmtDeleteRole = ({ role }) => {
    return `delete role ${role};`;
};
export const stmtForHumanDeleteRole = ({ role }) => {
    return `Delete the role __${role}__.`;
};
export const deleteRoleHandler = createSchemaStatementHandler({
    type: 'delete role',
    parse: line => {
        const match = /^(delete|remove) role (?<roleName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'delete role',
                role: formatRoleName(match.groups.roleName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanDeleteRole,
    apply: (stmt, builder) => {
        if (stmt.role === adminRoleName) {
            throw new Error(`Role ${stmt.role} is reserved. Admin role is automatically created and has all permissions. You can't modify it.`);
        }
        builder.updateSchema(it => {
            return it.removeAclRole(stmt.role);
        });
    },
});
//# sourceMappingURL=DeleteRoleStmt.js.map